import React from "react";
import styled from "styled-components";
import { InfoCircle } from "react-bootstrap-icons";
import {
  THEME,
  FlexRow,
  IconContainer,
  MessageBox,
} from "./OnboardingLayoutComponents";

// Styled components for the behalf mode indicator
const BehalfModeBanner = styled(MessageBox)`
  margin-bottom: ${THEME.spacing.lg};
  width: 100%;
  color: ${THEME.colors.text} !important;
  font-weight: bold;
`;

const ClientInfo = styled.span`
  color: ${THEME.colors.textSecondary};
  font-weight: 600;
  margin-left: ${THEME.spacing.sm};
`;

/**
 * BehalfModeIndicator Component
 *
 * Displays a visual indicator when an accountant is creating a client account
 * Shows the accountant's role and client information when available
 *
 * @param {Object} props - Component props
 * @param {string} props.userRole - The role of the accountant (SUPERVISOR, USERADMIN, etc.)
 * @param {string} props.clientName - Name of the client being onboarded (optional)
 * @returns {JSX.Element} The behalf mode indicator component
 */
const BehalfModeIndicator = ({ userRole, clientName }) => {
  const getRoleDisplayName = (role) => {
    switch (role) {
      case "SUPERVISOR":
        return "Supervisor";
      case "USERADMIN":
        return "User Admin";
      case "CUSTOMERADMIN":
        return "Customer Admin";
      default:
        return role;
    }
  };

  return (
    <BehalfModeBanner variant="info">
      <FlexRow gap={THEME.spacing.md} alignItems="center">
        <IconContainer size="18px" color={THEME.colors.info}>
          <InfoCircle size={14} />
        </IconContainer>
        <span>Creating client account as {getRoleDisplayName(userRole)}</span>
        {clientName && <ClientInfo>Client: {clientName}</ClientInfo>}
      </FlexRow>
    </BehalfModeBanner>
  );
};

export default BehalfModeIndicator;
